import script from "./MaterialEditor.client.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialEditor.client.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialEditor.client.vue?vue&type=style&index=0&id=3c97a698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c97a698"]])

export default __exports__